import { render, staticRenderFns } from "./Accountant.vue?vue&type=template&id=1cf1bcc6&scoped=true"
import script from "./Accountant.vue?vue&type=script&lang=js"
export * from "./Accountant.vue?vue&type=script&lang=js"
import style0 from "./Accountant.vue?vue&type=style&index=0&id=1cf1bcc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf1bcc6",
  null
  
)

export default component.exports